import {
  CheckmarkFilled16,
  Information16,
  WarningAlt16,
  WarningAltFilled16,
} from '@carbon/icons-react';
import React from 'react';
import styled from 'styled-components';
import { Color } from 'components/colors';

export enum CpAlertType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export const CpAlertTypeToColor: {
  [key in CpAlertType]: Color;
} = {
  [CpAlertType.Info]: 'blue',
  [CpAlertType.Success]: 'green',
  [CpAlertType.Warning]: 'yellow',
  [CpAlertType.Error]: 'red',
};

const AlertTypeToIcon: {
  [key in CpAlertType]: React.FC;
} = {
  [CpAlertType.Info]: Information16,
  [CpAlertType.Success]: CheckmarkFilled16,
  [CpAlertType.Warning]: WarningAlt16,
  [CpAlertType.Error]: WarningAltFilled16,
};

export interface CpAlertProps {
  type: CpAlertType;
  message: string;
}

const AlertWrapper = styled.div<{ color: Color }>`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: var(--spacing-03);
  background-color: ${(props) => `var(--cp-${props.color}-10)`};
  border-left: 4px solid ${(props) => `var(--cp-${props.color}-60)`};
  color: ${(props) => `var(--cp-${props.color}-60)`};

  svg {
    margin-right: var(--spacing-03);
    fill: ${(props) => `var(--cp-${props.color}-60)`};
  }
`;

export const CpAlert: React.FC<CpAlertProps> = ({ type, message }) => {
  const Icon = AlertTypeToIcon[type];

  return (
    <AlertWrapper color={CpAlertTypeToColor[type]}>
      <Icon />
      {message}
    </AlertWrapper>
  );
};
